const MAX_COL_WIDTH = 60;

function parseLine(line) {
  const trimmed = line.trim();
  const inner = trimmed.startsWith("|")
    ? trimmed.slice(1, trimmed.length - 1)
    : trimmed;
  const cells = inner.split("|").map((c) => c.trim());
  const isSeparator =
    cells.length > 0 && cells.every((c) => /^:?-+:?$/.test(c));
  return { cells, isSeparator };
}

export function alignTable(lines) {
  const rows = lines.map(parseLine);
  const colCount = rows.reduce(
    (max, row) => Math.max(max, row.cells.length),
    0
  );
  const widths = new Array(colCount).fill(0);
  rows.forEach((row) => {
    if (row.isSeparator) return;
    row.cells.forEach((cell, i) => {
      widths[i] = Math.min(MAX_COL_WIDTH, Math.max(widths[i], cell.length));
    });
  });
  return rows.map((row) => {
    if (row.isSeparator) {
      return (
        "| " + widths.map((w) => "-".repeat(Math.max(3, w))).join(" | ") + " |"
      );
    }
    const padded = [];
    for (let i = 0; i < colCount; i++) {
      padded.push((row.cells[i] || "").padEnd(widths[i] || 0));
    }
    return "| " + padded.join(" | ") + " |";
  });
}

export function cleanTable(lines) {
  return lines.map((line) => {
    if (!line.trim().startsWith("|")) return line;
    const { cells, isSeparator } = parseLine(line);
    if (isSeparator) {
      return "| " + cells.map(() => "---").join(" | ") + " |";
    }
    return "| " + cells.join(" | ") + " |";
  });
}

function transformTableBlocks(text, fn) {
  const lines = String(text || "").split("\n");
  const out = [];
  let i = 0;
  while (i < lines.length) {
    if (lines[i].trim().startsWith("|")) {
      const block = [];
      while (i < lines.length && lines[i].trim().startsWith("|")) {
        block.push(lines[i]);
        i++;
      }
      out.push(...fn(block));
    } else {
      out.push(lines[i]);
      i++;
    }
  }
  return out.join("\n");
}

export function alignTables(text) {
  return transformTableBlocks(text, alignTable);
}

export function cleanTables(text) {
  return transformTableBlocks(text, cleanTable);
}
